module.exports = __webpack_public_path__ + "static/img/SketchPng4bbc11381266b494fcc5486628bab4c8ed269c83d7c6bb2cebd8e56bec596318.2c138e44.png";